import {
  hasCapacitorClipboard,
  capacitorWriteClipboard,
  capacitorReadClipboard,
} from "../capacitor/clipboard";

let inFlightRead = null;

export function hasMobiLoudClipboard() {
  return (
    typeof window !== "undefined" &&
    typeof window.nativeFunctions?.copyToClipboard === "function" &&
    typeof window.nativeFunctions?.getFromClipboard === "function"
  );
}

function mobiLoudGetFromClipboard(timeout = 1000) {
  if (inFlightRead) {
    return inFlightRead;
  }

  inFlightRead = new Promise((resolve) => {
    let resolved = false;
    let timer = null;

    const finish = (value) => {
      if (resolved) {
        return;
      }
      resolved = true;
      if (timer) {
        clearTimeout(timer);
      }
      window.clipboardResult = () => {};
      inFlightRead = null;
      resolve(value);
    };

    const handler = (text) => finish(text ?? "");
    window.clipboardResult = handler;

    timer = setTimeout(() => finish(null), timeout);

    try {
      window.nativeFunctions.getFromClipboard();
    } catch {
      finish(null);
    }
  });

  return inFlightRead;
}

export async function copyToClipboard(text) {
  // Prefer the Capacitor shell, then the legacy MobiLoud bridge, then Web API.
  if (hasCapacitorClipboard()) {
    try {
      if (await capacitorWriteClipboard(text)) {
        return;
      }
    } catch {
      // Fall through to the next strategy.
    }
  }
  if (hasMobiLoudClipboard()) {
    try {
      window.nativeFunctions.copyToClipboard(text);
      return;
    } catch {
      // Fall through to Web API
    }
  }
  await navigator.clipboard.writeText(text);
}

export async function readFromClipboard() {
  if (hasCapacitorClipboard()) {
    const text = await capacitorReadClipboard();
    if (text !== null) {
      return text;
    }
  }
  if (hasMobiLoudClipboard()) {
    const text = await mobiLoudGetFromClipboard();
    if (text !== null) {
      return text;
    }
  }
  return await navigator.clipboard.readText();
}
